import { createSelector } from '@reduxjs/toolkit';

import { SubjectPropertyDataState } from '../../types.ts';
import { selectPropertyDataEntities } from './propertyDataSelectors/propertyDataSelectors.ts';

export const selectSubjectPropertyDataEntity = createSelector(
  [selectPropertyDataEntities],
  (propertyDataEntities) =>
    propertyDataEntities.subject
      ? (propertyDataEntities.subject as SubjectPropertyDataState).subjectData
      : null,
);
